import { SxProps } from '@mui/material';

export const grid: SxProps = {
  direction: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '80vh',
};
